module.exports = __webpack_public_path__ + "static/img/2.46aa6379.png";